/** Delay after last search/filter change before calling list APIs */
export const ADMIN_LIST_FILTERS_DEBOUNCE_MS = 2000;
